import { ComponentProps } from 'react';

import Card from './Card';
import { useCanAccess } from '../app/routes/access';
import { AppRoutes } from '../app/routes/utils';

type Props = Omit<ComponentProps<typeof Card>, 'route'> & { to: AppRoutes };

/** Card on a parent landing page (e.g. `/settings`), shown only when its route is accessible. */
function LandingCard({ to, ...card }: Props) {
  const canAccess = useCanAccess(to);

  return canAccess ? <Card {...card} route={{ to }} /> : null;
}

export default LandingCard;
